module.exports = __webpack_public_path__ + "img/regsucleftbg.b6219211.png";